export default "__VITE_ASSET__jMovGUq5__ 800w, __VITE_ASSET__qIVCHTmT__ 1280w, __VITE_ASSET__Dsw8f5mn__ 1920w";